import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { filteredStoresLoadingVar, filteredStoresVar } from 'src/infrastructure/local_state';

export const useFilteredStores = () => {
    const [filteredStores] = useReactiveVar(filteredStoresVar);
    const [filteredStoresLoading] = useReactiveVar(filteredStoresLoadingVar);

    return [filteredStores, { loading: filteredStoresLoading }] as const;
};
